module.exports = __webpack_public_path__ + "efc4d1b4e3af25e449134bb86c8a88a5.pdf";